import type { IArticleConfig } from '~/config/article';
import widgetsConfig from '~/config/widgets.config';
import Iframe from './Iframe';
import Session from '~/modules/Session';

// Typescript typings
// import { cachedKeys } from '~/config/keys';

class EmotesIframe extends Iframe {
  constructor(
    id: string,
    readonly config: IArticleConfig
  ) {
    /** ‼ ⚠ Call superclass constructor (Iframe class) */
    // tslint:disable:object-literal-sort-keys
    super(
      id,
      'Vuukle Emotes Widget',
      widgetsConfig.urls.emotes,
      {
        amp: config.amp,
        apiKey: config.apiKey,
        host: config.host,

        articleId: config.articleId,
        img: config.img,
        author: config.author || undefined,
        tags: config.tags,
        title: config.title,
        url: config.url,
        /** if true then article cards display image in top and text on bottom instead of small picture on left and text on right side */
        totWideImg: config.recommendationsWideImages,
        gr: config.globalRecommendations,
        /** Custom links structure for recommended articles link */
        link: config.link,
        /** Hide recommended articles that are displayed after recommendation select */
        // hideArticles: config.emotes && config.emotes.hideRecommendedArticles,
        /** Hide emote labels */
        hideAllLabels: config.emotes && config.emotes.hideAllLabels,
        /** Emotes to disable, it's passed as array [1,4] -> disabled/hides 1st and 4th emoji */
        disable: config.emotes && JSON.stringify(config.emotes.disable),
        font: config.theme && config.theme.font,
        /**
         * Used to reduce an api call to getEmoteRatings.
         * Will also hide Vuukle branding if comments widget is enabled. So in that case branding is displayed only in comments widget
         */
        commentsEnabled:
          config.comments &&
          config.comments.enabled &&
          Boolean(document.querySelector(`div[id*=${widgetsConfig.selectors.comments.substring(1)}]`)),
        isCustomText: Boolean(config.customTranslationUrl),
        // useKV: cachedKeys.includes(config.apiKey),
        useKV: false,
        version: widgetsConfig.versions.emotes,
        language: config.language || 'en',
        isAndroidSDK: config.sdk && Session.os.includes('Android'),
      },
      false,
      false
    );
    this.iframe.style.minHeight = '145px';
    this.iframe.style.display = 'flex';
    this.iframe.style.margin = 'auto';
    this.intersectionObserverOptions = {
      threshold: 0,
      rootMargin: '400px 400px 400px 400px',
    };
    // tslint:enable:object-literal-sort-keys
    /**
     * Post custom card styles and badge styles on load
     * ---
     * It's needed because custom styles config object can be very big
     * and we can't simply pass it using query string inside URL
     */
    this.onLoad((iframeWindow) =>
      iframeWindow.postMessage({ cardStyles: config.theme && config.theme.cardStyles }, '*')
    );
    this.onLoad((iframeWindow) =>
      iframeWindow.postMessage({ badgeStyles: config.theme && config.theme.badgeStyles }, '*')
    );
  }

  //   protected insertSkeleton(): void {
  //     super.insertSkeleton();
  //     const baseSkeletonPiece = document.createElement('span');
  //     baseSkeletonPiece.style.cssText = `
  //       display: block;
  //       background: linear-gradient(
  //           to right,
  //           rgba(255, 255, 255, 0),
  //           rgba(255, 255, 255, 0.5) 50%,
  //           rgba(255, 255, 255, 0) 80%
  //         ),
  //         lightgray;
  //       background-repeat: repeat-y;
  //       background-size: 50px 500px;
  //       background-position: 0 0;
  //       animation: iframe-skeleton-animation 1s infinite;
  //     `;

  //     const emoteSkeletonHeader = baseSkeletonPiece.cloneNode() as HTMLSpanElement;
  //     emoteSkeletonHeader.style.height = '20px';
  //     emoteSkeletonHeader.style.width = '210px';
  //     emoteSkeletonHeader.style.marginBottom = '10px';

  //     const emoteSkeletonEmotesWrapper = document.createElement('div');
  //     emoteSkeletonEmotesWrapper.style.cssText = `
  //       display: flex;
  //       justify-content: space-between;
  //       flex-direction: row;
  //     `;

  //     const emoticonSkeletons = [];

  //     for (let i = 0; i < 6; i++) {
  //       const emoticonWrapper = document.createElement('div');
  //       const emoticonPiece = baseSkeletonPiece.cloneNode() as HTMLSpanElement;
  //       const emoticonNamePiece = baseSkeletonPiece.cloneNode() as HTMLSpanElement;

  //       emoticonWrapper.style.display = 'flex';
  //       emoticonWrapper.style.flexDirection = 'column';
  //       emoticonWrapper.style.alignItems = 'center';

  //       emoticonPiece.style.height = '100px';
  //       emoticonPiece.style.width = '100px';
  //       emoticonPiece.style.borderRadius = '50%';

  //       emoticonNamePiece.style.height = '20px';
  //       emoticonNamePiece.style.width = '55px';
  //       emoticonNamePiece.style.marginTop = '10px';

  //       emoticonWrapper.appendChild(emoticonPiece);
  //       emoticonWrapper.appendChild(emoticonNamePiece);

  //       emoticonSkeletons.push(emoticonWrapper);
  //     }

  //     emoticonSkeletons.forEach((skeleton) => {
  //       emoteSkeletonEmotesWrapper.appendChild(skeleton);
  //     });

  //     this.iframeSkeleton.appendChild(emoteSkeletonHeader);
  //     this.iframeSkeleton.appendChild(emoteSkeletonEmotesWrapper);
  //   }
  // }
}

export default EmotesIframe;
